import 'vanilla-infinite-marquee/css';
import InfiniteMarquee from 'vanilla-infinite-marquee';

import './view.scss';

document.addEventListener('DOMContentLoaded', function () {
    const marquees = document.querySelectorAll('.wp-block-base-marquee');

    marquees.forEach((marquee) => {
        const container = marquee.querySelector('.marquee-container');

        // TODO - Dynamically calculate required duplicateCount

        new InfiniteMarquee({
            element: container,
            speed: container.dataset.speed ? (container.offsetWidth / container.dataset.speed) * 1000 : 5000,
            smoothEdges: false,
            direction: container.dataset.direction ? container.dataset.direction : 'right',
            spaceBetween: '27px', //TODO - Bring in from block settings
            duplicateCount: 2,
            // TODO - Add in mobile options to block settings & editor
        });
    });
});
